<template>
	<component
		v-if="visible"
		:is="componentOfPart(selectedPart)"
		:part="partRef(selectedPart)"
		:data="localData"
		:readonly="ro"
		:viewmode="vm"></component>
</template>

<script setup lang="ts">
import useContainer, { type ContainerProps, containerProps } from "./Container";
import {ref, defineProps, computed} from "vue";
import {Variant} from "@t/fd/layout/Variant.ts";
import {FormPartOrReference} from "@t/fd/FormPartOrReference.ts";

const props = defineProps({
	...containerProps,
}) as ContainerProps;

const v = computed<Variant>(() => props.part as Variant);

const { componentOfPart, partRef, localData, ro, vm, visible, evalExpression } = useContainer(props);

const selectedPart = computed<FormPartOrReference>(() => {
	for (let variant of v.value.variants) {
		if (variant.condition == null) return variant.part;
		if (evalExpression("condition", variant)) return variant.part;
	}
	// return the last item if there is no match
	return v.value.variants[v.value.variants.length - 1].part;
});
</script>

<style>

</style>